import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork} from "redux-saga/effects";
import AuthService from "../../services/auth.service";
import {buildLegacyUserFromAuthUser, setAuthTokens} from "../../services/utils";
import {applyAuthHeader} from "../../services/authInterceptor";

function* loginStart(action) {
  try {
    // Login accepts either an email or a phone number in the same field —
    // auth-service resolves which one it is server-side (see auth.service.ts).
    const identifier = (action.payload.ssoId && action.payload.ssoId !== "")
      ? action.payload.ssoId
      : action.payload.email;
    const data = {email: identifier, password: action.payload.password};
    const response = yield AuthService.login(data);

    if (response.data.requiresMfa) {
      yield put(actions.loginFailure("This account requires a verification code — MFA login isn't supported here yet. Please contact support."));
      return;
    }

    const {accessToken, refreshToken, user} = response.data;
    setAuthTokens({accessToken, refreshToken});
    applyAuthHeader(accessToken);
    yield put(actions.loginSuccess(buildLegacyUserFromAuthUser(user)));
  } catch (err) {
    console.log('err ', err)
    let error = err?.response?.data?.message;

    if (!error) {
      error = err?.response?.message || "Network error";
    }
    yield put(actions.loginFailure(Array.isArray(error) ? error.join(', ') : error));
  }
}

function* loginStartSaga() {
  yield takeEvery(actionsTypes.LOGIN_START, loginStart);
}

// The signup form's tradeRoles ('buyer'/'seller'/'both') don't map 1:1 onto
// auth-service's Role enum (ADMIN/BUYER/SELLER, no combined role) — 'both'
// collapses to SELLER since sellers aren't restricted from buying.
const ROLE_MAP = {buyer: 'BUYER', seller: 'SELLER', both: 'SELLER'};

function* signUpStart(action) {
  try {
    // The Company Name field defaults to the placeholder text "Personal"
    // (see signUp/constant.js) rather than being empty, so "has a company
    // name" means "non-empty AND not that default placeholder".
    const hasCompanyName = action.payload.provider && action.payload.provider !== 'Personal';
    const data = {
      email: action.payload.email,
      password: action.payload.password,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName,
      phone: action.payload.mobileNumber,
      role: ROLE_MAP[action.payload.businessSelected] || 'BUYER',
      organizationName: hasCompanyName ? action.payload.provider : `${action.payload.firstName} ${action.payload.lastName}`,
      organizationType: hasCompanyName ? 'COMPANY' : 'INDIVIDUAL',
      organizationCountry: action.payload.country || 'Pakistan',
    };

    const response = yield AuthService.register(data);
    const {accessToken, refreshToken, user} = response.data;
    setAuthTokens({accessToken, refreshToken});
    applyAuthHeader(accessToken);
    yield put(actions.loginSuccess(buildLegacyUserFromAuthUser(user)));
    yield put(actions.signupSuccess('Successfully registered', action.payload?.signup));
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = "network error"
    }
    yield put(actions.signupFailure(Array.isArray(error) ? error.join(', ') : error));
  }
}

function* signupStartSaga() {
  yield takeEvery(actionsTypes.SIGNUP_START, signUpStart);
}

export function* authSaga() {
  yield all([fork(loginStartSaga), fork(signupStartSaga),]);
}
